module.exports = __webpack_public_path__ + "img/crown_coin2.91bb70ef.png";